import { createMutationHelper } from '@utils/swr'
import { type ECommerceUpdateOrderRequest } from '../types/apiRequest'
import { type ECommerceApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<ECommerceApis['put']['updateOrder'], never, ECommerceUpdateOrderRequest>({
  client: 'eCommerce',
  key: '/orders/:id/service_info',
  fetcher: (_url, { arg, client }) => {
    const { id, ...rest } = arg
    return client.put(`/orders/${id}/service_info`, rest)
  },
})

export const useApiECommerceUpdateOrder = useMutation
